<template>
  <div class="trainer">
    <div class="header">
      <div class="selectors">
        <select v-model="script" @change="reset">
          <option value="hiragana">Hiragana</option>
          <option value="katakana">Katakana</option>
        </select>
        <select v-model="level" @change="reset">
          <option v-for="l in levels" :value="l" :key="l">
            Level {{ l }}
          </option>
        </select>
        <button @click="toggleGame">
          {{ gameMode ? 'Study Mode' : 'Game Mode' }}
        </button>
      </div>
      <div class="progress">
        <div class="bar" :style="{width:progress+'%'}"></div>
      </div>
    </div>
    <div class="card">
      <div class="kana" @click="speak(current.k)">
        {{ current.k }}
      </div>
      <input
        ref="input"
        v-model="answer"
        @keyup.enter="check"
        placeholder="type romaji"
      />
      <div v-if="feedback" class="feedback">
        {{ feedback }}
      </div>
      <div v-if="showAnswer" class="answer">
        {{ current.r }}
      </div>
      <div class="buttons">
        <button @click="check">Check</button>
        <button @click="showAnswer=true">Show</button>
        <button @click="next">Skip</button>
      </div>
    </div>
    <div class="stats">
      <span>Seen {{ stats.seen }}</span>
      <span>Correct {{ stats.correct }}</span>
      <span v-if="gameMode">
        Round {{ round }} / 10
      </span>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      script    : "hiragana",
      level     : 1,
      levels    : [1, 2, 3, 4, 5, 6],
      cards     : [],
      current   : {},
      answer    : "",
      feedback  : "",
      showAnswer: false,
      stats     : {
        seen   : 0,
        correct: 0
      },
      weights   : {},
      gameMode  : false,
      round     : 1
    }
  },

  mounted() {
    this.initCards()
    this.load()
    this.next()
  },

  computed: {
    pool() {
      return this.cards.filter(c =>
        c.script === this.script && c.l <= this.level
      )
    },
    progress() {
      return Math.min(100, (this.stats.correct / 100) * 100)
    }
  },

  methods: {
    initCards() {
      this.cards = [
// vowels
        {
          k     : "あ",
          r     : "a",
          l     : 1,
          script: "hiragana"
        },
        {
          k     : "い",
          r     : "i",
          l     : 1,
          script: "hiragana"
        },
        {
          k     : "う",
          r     : "u",
          l     : 1,
          script: "hiragana"
        },
        {
          k     : "え",
          r     : "e",
          l     : 1,
          script: "hiragana"
        },
        {
          k     : "お",
          r     : "o",
          l     : 1,
          script: "hiragana"
        },

// k
        {
          k     : "か",
          r     : "ka",
          l     : 2,
          script: "hiragana"
        },
        {
          k     : "き",
          r     : "ki",
          l     : 2,
          script: "hiragana"
        },
        {
          k     : "く",
          r     : "ku",
          l     : 2,
          script: "hiragana"
        },
        {
          k     : "け",
          r     : "ke",
          l     : 2,
          script: "hiragana"
        },
        {
          k     : "こ",
          r     : "ko",
          l     : 2,
          script: "hiragana"
        },

// s
        {
          k     : "さ",
          r     : "sa",
          l     : 2,
          script: "hiragana"
        },
        {
          k     : "し",
          r     : "shi",
          l     : 2,
          script: "hiragana"
        },
        {
          k     : "す",
          r     : "su",
          l     : 2,
          script: "hiragana"
        },
        {
          k     : "せ",
          r     : "se",
          l     : 2,
          script: "hiragana"
        },
        {
          k     : "そ",
          r     : "so",
          l     : 2,
          script: "hiragana"
        },

// combo
        {
          k     : "きゃ",
          r     : "kya",
          l     : 6,
          script: "hiragana"
        },
        {
          k     : "きゅ",
          r     : "kyu",
          l     : 6,
          script: "hiragana"
        },
        {
          k     : "きょ",
          r     : "kyo",
          l     : 6,
          script: "hiragana"
        },

        {
          k     : "しゃ",
          r     : "sha",
          l     : 6,
          script: "hiragana"
        },
        {
          k     : "しゅ",
          r     : "shu",
          l     : 6,
          script: "hiragana"
        },
        {
          k     : "しょ",
          r     : "sho",
          l     : 6,
          script: "hiragana"
        },

// small tsu example
        {
          k     : "がっこう",
          r     : "gakkou",
          l     : 6,
          script: "hiragana"
        },
        {
          k     : "きって",
          r     : "kitte",
          l     : 6,
          script: "hiragana"
        }
      ]
    },

    reset() {
      this.stats = {
        seen   : 0,
        correct: 0
      }
      this.round = 1
      this.next()
    },
    next() {
      if (this.gameMode && this.round > 10) {
        alert("Score " + this.stats.correct + "/10")
        this.round = 1
        this.stats = {
          seen   : 0,
          correct: 0
        }
      }
      this.answer     = ""
      this.feedback   = ""
      this.showAnswer = false
      const weighted  = []
      this.pool.forEach(c => {
        const w = this.weights[c.k] || 1
        for (let i = 0; i < w; i++) weighted.push(c)
      })
      this.current = weighted[Math.floor(Math.random() * weighted.length)]
      this.stats.seen++
      this.round++
      this.$nextTick(() => this.$refs.input.focus())
    },
    check() {
      if (!this.answer) return
      if (this.answer.toLowerCase() === this.current.r) {
        this.feedback = "✔ correct"
        this.stats.correct++
        this.adjust(-1)
        setTimeout(this.next, 600)
      } else {
        this.feedback = "✘ wrong"
        this.adjust(3)
        this.showAnswer = true
      }
      this.save()
    },
    adjust(v) {
      const k = this.current.k
      if (!this.weights[k]) this.weights[k] = 1
      this.weights[k] += v
      if (this.weights[k] < 1) this.weights[k] = 1
    },
    toggleGame() {
      this.gameMode = !this.gameMode
      this.reset()
    },
    speak(t) {
      const u = new SpeechSynthesisUtterance(t)
      u.lang  = "ja-JP"
      speechSynthesis.cancel()
      speechSynthesis.speak(u)
    },
    save() {
      localStorage.setItem("kanaPro", JSON.stringify({
        stats  : this.stats,
        weights: this.weights
      }))
    },
    load() {
      const d = localStorage.getItem("kanaPro")
      if (!d) return
      const j      = JSON.parse(d)
      this.stats   = j.stats || this.stats
      this.weights = j.weights || {}
    }
  }
}
</script>

<style>

body {
  background: #f4f6fb;
}

.trainer {
  max-width: 420px;
  margin: 60px auto;
  font-family: system-ui;
  text-align: center;
}

.selectors {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-bottom: 10px;
}

.progress {
  height: 16px;
  background: #ddd;
  border-radius: 3px;
  margin-bottom: 20px;
}

.bar {
  height: 100%;
  background: #6366f1;
}

.card {
  background: white;
  padding: 32px;
  border-radius: 18px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.kana {
  font-size: 120px;
  margin-bottom: 20px;
  cursor: pointer;
}

input {
  width: 100%;
  padding: 12px;
  font-size: 18px;
  border-radius: 8px;
  border: 1px solid #ddd;
  text-align: center;
}

.feedback {
  margin-top: 10px;
  font-weight: 600;
}

.answer {
  margin-top: 8px;
  color: #666;
}

.buttons {
  margin-top: 16px;
}

.selectors button, .buttons button {
  margin: 4px;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  background: #eee;
  cursor: pointer;
}
.selectors button{
  margin: 0;
}
.stats {
  margin-top: 16px;
  display: flex;
  justify-content: center;
  gap: 14px;
  color: #888;
}

</style>